<ng-container *ngIf="filter[dateType]?.value; else notSelected">
  <div class="drive-filter-item active" matRipple>
    <p class="flwmn-para-1 mb-0 text-white">
      <span class="flwmn-text-neutral">{{ filter[dateType].name }}</span>
      <!-- {{ filter[dateType].value?.start | date : 'mediumDate' }} -
      {{ filter[dateType].value?.end | date : 'mediumDate' }} -->
    </p>

    <img matRipple (click)="clearDate()" src="assets/icons/close.svg" alt="" />
  </div>
</ng-container>

<ng-template #notSelected>
  <div class="drive-filter-item" matRipple [matMenuTriggerFor]="created">
    <p class="flwmn-para-1 mb-0 text-capitalize">Timeline</p>
    <img matRipple src="assets/icons/arrow-down.svg" alt="" />
  </div>

  <mat-menu #created="matMenu" class="menu filter-dropdown-menu">
    <div class="menu-content">
      <div class="left-section">
        <!-- <p
          mat-menu-item
          class="flwmn-para-1 flwmn-text-neutral mb-0 text-uppercase"
        >
          {{ dateType }}
        </p> -->

        <button
          mat-menu-item
          *ngFor="let item of dateFilterItems"
          (click)="
            item === dateFilterItemsEnum.SET_A_RANGE
              ? toggleShowRange($event)
              : setFilterValue(item)
          "
        >
          <div class="item-container">
            <p class="item-text">{{ item?.name }}</p>

            <div
              class="item-icon"
              *ngIf="item === dateFilterItemsEnum.SET_A_RANGE"
            >
              <img matRipple src="assets/icons/arrow-right.svg" alt="" />
            </div>
          </div>
        </button>
      </div>

      <div
        class="right-section"
        [ngClass]="{ show: showRange }"
        *ngIf="showRange"
      >
        <div class="right-section-form">
          <p class="flwmn-para-1 fw-600 mb-0">Range</p>

          <div class="divider">&nbsp;</div>

          <div class="input-style1" (click)="$event.stopPropagation()">
            <label class="input-label">From</label>

            <mat-form-field appearance="outline" [style.width.%]="100">
              <input
                matInput
                [matDatepicker]="fromDatePicker"
                placeholder="DD/MM/YYYY"
                [(ngModel)]="fromDate"
              />

              <mat-datepicker-toggle matSuffix [for]="fromDatePicker">
                <img
                  matDatepickerToggleIcon
                  src="/assets/icons/calendar.svg"
                  alt="Calendar Icon"
                  class="calendar"
                />
              </mat-datepicker-toggle>

              <mat-datepicker #fromDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="input-style1" (click)="$event.stopPropagation()">
            <label class="input-label">To</label>

            <mat-form-field appearance="outline" [style.width.%]="100">
              <input
                matInput
                [matDatepicker]="toDatePicker"
                placeholder="DD/MM/YYYY"
                [(ngModel)]="toDate"
              />

              <mat-datepicker-toggle matSuffix [for]="toDatePicker">
                <img
                  matDatepickerToggleIcon
                  src="/assets/icons/calendar.svg"
                  alt="Calendar Icon"
                  class="calendar"
                />
              </mat-datepicker-toggle>

              <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="cta-container" *ngIf="showRange">
      <button
        matRipple
        type="button"
        class="btn flwmn-btn-primary-outline flwmn-btn-md"
        (click)="toggleShowRange()"
      >
        Cancel
      </button>

      <button
        (click)="setFilterValue(dateFilterItemsEnum.SET_A_RANGE)"
        [disabled]="!fromDate || !toDate"
        matRipple
        type="button"
        class="btn flwmn-btn-primary flwmn-btn-md"
      >
        Apply
      </button>
    </div>
  </mat-menu>
</ng-template>
